import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';

const SETORES = [
  'Atendimento', 'Arte Finalista', 'Pré Produção',
  'Impressão Offset', 'Impressão Digital', 'Impressão Fora',
  'Corte', 'Acabamento', 'Expedição',
];

const PROCESSOS_PADRAO = {
  'Atendimento':       ['Concluído'],
  'Arte Finalista':    ['Concluído'],
  'Pré Produção':      ['Concluído'],
  'Impressão Offset':  ['Concluído'],
  'Impressão Digital': ['Concluído'],
  'Impressão Fora':    ['Concluído'],
  'Acabamento':        ['Concluído'],
  'Corte':             ['Concluído'],
  'Expedição':         ['Concluído'],
};

const COR_SETOR = {
  'Atendimento':       '#00c9db',
  'Arte Finalista':    '#a78bfa',
  'Pré Produção':      '#fbbf24',
  'Impressão Offset':  '#4f8ef7',
  'Impressão Digital': '#818cf8',
  'Impressão Fora':    '#c084fc',
  'Acabamento':        '#4ade80',
  'Corte':             '#f97316',
  'Expedição':         '#34d399',
};

// ── Modal de criar / editar funcionário ──────────────────────────────────────
function ModalFuncionario({ usuario, onClose, onSalvo }) {
  const editando = !!usuario;

  const [nome,          setNome]          = useState(usuario?.nome          || '');
  const [email,         setEmail]         = useState(usuario?.email         || '');
  const [senha,         setSenha]         = useState('');
  const [perfil,        setPerfil]        = useState(usuario?.perfil        || 'funcionario');
  const [acessoTotal,   setAcessoTotal]   = useState(usuario?.acesso_total  || false);
  // Unifica setor principal + setores_acesso em um único conjunto de permissões
  const setoresIniciais = usuario
    ? [...new Set([...(usuario.setores_acesso || []), usuario.setor].filter(s => s && s !== 'Administrador'))]
    : [];
  const [setoresAcesso, setSetoresAcesso] = useState(setoresIniciais);
  const [salvando,      setSalvando]      = useState(false);
  const [erro,          setErro]          = useState('');

  function toggleSetor(s) {
    setSetoresAcesso(prev =>
      prev.includes(s) ? prev.filter(x => x !== s) : [...prev, s]
    );
  }

  async function salvar(e) {
    e.preventDefault();
    setErro('');
    setSalvando(true);
    try {
      // Admin não tem setor específico — é geral por definição
      // Para funcionários, o setor principal é o primeiro setor marcado (detalhe interno)
      const setorPrimario = setoresAcesso[0] || SETORES[0];
      const dados = perfil === 'admin'
        ? { nome, email, perfil, setor: 'Administrador', acesso_total: true, setores_acesso: [] }
        : { nome, email, perfil, setor: setorPrimario, acesso_total: acessoTotal, setores_acesso: setoresAcesso };
      if (senha) dados.senha = senha;
      if (!editando) {
        if (!senha) { setErro('Senha é obrigatória para novo funcionário.'); setSalvando(false); return; }
        await api.criarUsuario(dados);
      } else {
        await api.atualizarUsuario(usuario.id, dados);
      }
      onSalvo();
      onClose();
    } catch (err) {
      setErro(err.message);
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(0,0,0,0.78)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem', backdropFilter: 'blur(4px)' }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ background: '#141414', border: '1px solid #2a2a2a', borderTop: '4px solid #f0a500', borderRadius: '16px', width: '100%', maxWidth: '560px', maxHeight: '90vh', overflowY: 'auto', fontFamily: "'DM Sans', sans-serif" }}
      >
        <form onSubmit={salvar}>
          <div style={{ padding: '1.75rem' }}>

            {/* Título */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
              <h2 style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.6rem', color: '#e0e0e0', margin: 0, letterSpacing: '0.08em' }}>
                {editando ? 'EDITAR FUNCIONÁRIO' : 'NOVO FUNCIONÁRIO'}
              </h2>
              <button type="button" onClick={onClose} style={{ background: 'transparent', border: 'none', color: '#555', fontSize: '1.5rem', cursor: 'pointer', lineHeight: 1 }}>×</button>
            </div>

            {/* Dados básicos */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={labelStyle}>Nome</label>
                <input value={nome} onChange={e => setNome(e.target.value)} required style={inputStyle} placeholder="Nome completo" />
              </div>
              <div>
                <label style={labelStyle}>Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required style={inputStyle} placeholder="email@grafica.com" />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={labelStyle}>{editando ? 'Nova Senha' : 'Senha'}</label>
                <input type="password" value={senha} onChange={e => setSenha(e.target.value)} required={!editando} autoComplete="new-password" style={{ ...inputStyle, WebkitBoxShadow: '0 0 0 1000px #1a1a1a inset', WebkitTextFillColor: '#e0e0e0' }} placeholder="" />
              </div>
            </div>

            {/* Perfil */}
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={labelStyle}>Perfil</label>
              <div style={{ display: 'flex', gap: '10px' }}>
                {[
                  { valor: 'funcionario', label: 'Funcionário', desc: 'Acesso ao Kanban e bipagem' },
                  { valor: 'admin', label: 'Administrador', desc: 'Acesso total + relatórios + gestão' },
                ].map(op => (
                  <button
                    key={op.valor}
                    type="button"
                    onClick={() => setPerfil(op.valor)}
                    style={{
                      flex: 1, padding: '10px 14px', borderRadius: '10px', cursor: 'pointer',
                      border: `2px solid ${perfil === op.valor ? (op.valor === 'admin' ? '#f0a500' : '#4f8ef7') : '#2a2a2a'}`,
                      background: perfil === op.valor ? (op.valor === 'admin' ? 'rgba(240,165,0,0.1)' : 'rgba(79,142,247,0.1)') : '#1a1a1a',
                      textAlign: 'left', transition: 'all 0.15s',
                    }}
                  >
                    <p style={{ margin: 0, fontWeight: 700, fontSize: '0.85rem', color: perfil === op.valor ? (op.valor === 'admin' ? '#f0a500' : '#4f8ef7') : '#888' }}>{op.label}</p>
                    <p style={{ margin: '2px 0 0 0', fontSize: '0.72rem', color: '#555' }}>{op.desc}</p>
                  </button>
                ))}
              </div>
            </div>

            {/* Permissões de setor — oculto para admin (admin é sempre geral) */}
            {perfil === 'admin' && (
              <div style={{ background: 'rgba(240,165,0,0.06)', border: '1px solid rgba(240,165,0,0.2)', borderRadius: '10px', padding: '12px 14px', marginBottom: '1.25rem' }}>
                <p style={{ margin: 0, fontSize: '0.82rem', color: '#f0a500' }}>
                  Administradores têm acesso irrestrito a todos os setores, relatórios e gestão — sem setor específico.
                </p>
              </div>
            )}
            {perfil !== 'admin' && (
            <div style={{ border: '1px solid #2a2a2a', borderRadius: '12px', padding: '14px 16px', marginBottom: '1.25rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                <span style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1rem', color: '#c8c8c8', letterSpacing: '0.08em' }}>ACESSO AOS SETORES</span>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                  <span style={{ fontSize: '0.78rem', color: acessoTotal ? '#4ade80' : '#666' }}>Acesso a todos os setores</span>
                  <div
                    onClick={() => setAcessoTotal(v => !v)}
                    style={{
                      width: '38px', height: '20px', borderRadius: '10px', cursor: 'pointer',
                      background: acessoTotal ? '#4ade80' : '#333',
                      position: 'relative', transition: 'background 0.2s',
                    }}
                  >
                    <div style={{
                      position: 'absolute', top: '2px', left: acessoTotal ? '20px' : '2px',
                      width: '16px', height: '16px', borderRadius: '50%', background: '#fff',
                      transition: 'left 0.2s',
                    }} />
                  </div>
                </label>
              </div>

              {acessoTotal ? (
                <p style={{ fontSize: '0.78rem', color: '#4ade80', margin: 0 }}>
                  Este funcionário pode bipar em qualquer setor.
                </p>
              ) : (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {SETORES.map(s => {
                    const marcado = setoresAcesso.includes(s);
                    const cor = COR_SETOR[s] || '#888';
                    return (
                      <button
                        key={s}
                        type="button"
                        onClick={() => toggleSetor(s)}
                        style={{
                          display: 'flex', alignItems: 'center', gap: '6px',
                          padding: '5px 11px', borderRadius: '20px', cursor: 'pointer',
                          border: `1px solid ${marcado ? cor : '#2a2a2a'}`,
                          background: marcado ? cor + '18' : '#1a1a1a',
                          transition: 'all 0.15s',
                        }}
                      >
                        <div style={{
                          width: '12px', height: '12px', borderRadius: '3px',
                          border: `2px solid ${marcado ? cor : '#444'}`,
                          background: marcado ? cor : 'transparent',
                          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                        }}>
                          {marcado && <svg width="8" height="8" viewBox="0 0 10 10"><polyline points="1,5 4,8 9,2" fill="none" stroke="#000" strokeWidth="1.8" strokeLinecap="round"/></svg>}
                        </div>
                        <span style={{ fontSize: '0.75rem', color: marcado ? cor : '#555', fontWeight: marcado ? 600 : 400 }}>
                          {s}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}
              <p style={{ fontSize: '0.68rem', color: '#444', margin: '10px 0 0 0' }}>
                Acesso total ≠ Admin — não libera relatórios nem gestão.
              </p>
            </div>
            )}

            {erro && <p style={{ color: '#e05555', fontSize: '0.85rem', margin: '0 0 1rem 0' }}>{erro}</p>}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button type="button" onClick={onClose} style={{ ...btnStyle, background: '#1a1a1a', border: '1px solid #2a2a2a', color: '#888' }}>
                Cancelar
              </button>
              <button type="submit" disabled={salvando} style={{ ...btnStyle, background: '#f0a500', border: '1px solid #f0a500', color: '#0d0d0d', fontWeight: 700 }}>
                {salvando ? 'Salvando...' : editando ? 'Salvar alterações' : 'Criar funcionário'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

// ── Estilos reutilizáveis ────────────────────────────────────────────────────
const labelStyle = {
  display: 'block', fontSize: '0.72rem', color: '#666',
  fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em',
  marginBottom: '5px', fontFamily: "'DM Sans', sans-serif",
};
const inputStyle = {
  width: '100%', boxSizing: 'border-box', background: '#1a1a1a',
  border: '1px solid #2a2a2a', borderRadius: '9px', padding: '9px 12px',
  color: '#e0e0e0', fontSize: '0.9rem', fontFamily: "'DM Sans', sans-serif",
  outline: 'none',
};
const btnStyle = {
  padding: '9px 20px', borderRadius: '9px', cursor: 'pointer',
  fontSize: '0.85rem', fontFamily: "'DM Sans', sans-serif", transition: 'all 0.15s',
};

// ── Card de funcionário ──────────────────────────────────────────────────────
function CardFuncionario({ usuario, onEditar, onDeletar, meuId }) {
  const [confirmando, setConfirmando] = useState(false);
  const cor = usuario.perfil === 'admin' ? '#f0a500' : (COR_SETOR[usuario.setor] || '#888');
  const iniciais = usuario.nome.split(' ').slice(0, 2).map(p => p[0]).join('').toUpperCase();

  return (
    <div style={{
      background: '#141414', border: '1px solid #1e1e1e',
      borderLeft: `4px solid ${cor}`,
      borderRadius: '12px', padding: '16px 18px',
      display: 'flex', alignItems: 'center', gap: '14px',
      transition: 'border-color 0.15s',
    }}>
      {/* Avatar */}
      <div style={{
        width: '42px', height: '42px', borderRadius: '50%',
        background: cor + '25', border: `2px solid ${cor}50`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0, fontFamily: "'Bebas Neue', cursive", fontSize: '1rem', color: cor,
      }}>
        {iniciais}
      </div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '3px' }}>
          <span style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: '0.95rem', color: '#e0e0e0' }}>
            {usuario.nome}
          </span>
          {usuario.perfil === 'admin' && (
            <span style={{ background: 'rgba(240,165,0,0.15)', color: '#f0a500', borderRadius: '20px', padding: '1px 8px', fontSize: '0.68rem', fontWeight: 700, border: '1px solid rgba(240,165,0,0.3)' }}>
              ADMIN
            </span>
          )}
          {usuario.acesso_total && usuario.perfil !== 'admin' && (
            <span style={{ background: 'rgba(74,222,128,0.12)', color: '#4ade80', borderRadius: '20px', padding: '1px 8px', fontSize: '0.68rem', fontWeight: 700, border: '1px solid rgba(74,222,128,0.25)' }}>
              ACESSO TOTAL
            </span>
          )}
        </div>
        <p style={{ margin: '0 0 5px 0', fontSize: '0.78rem', color: '#555', fontFamily: "'DM Sans', sans-serif" }}>
          {usuario.email}
        </p>
        {usuario.perfil !== 'admin' && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
            {usuario.acesso_total ? (
              <span style={{ background: 'rgba(74,222,128,0.12)', color: '#4ade80', borderRadius: '20px', padding: '1px 9px', fontSize: '0.7rem', fontWeight: 600, border: '1px solid rgba(74,222,128,0.25)' }}>
                Todos os setores
              </span>
            ) : (usuario.setores_acesso?.length > 0 ? usuario.setores_acesso : [usuario.setor]).filter(Boolean).map(s => (
              <span key={s} style={{ background: (COR_SETOR[s] || '#888') + '18', color: COR_SETOR[s] || '#888', borderRadius: '20px', padding: '1px 9px', fontSize: '0.7rem', fontWeight: 600 }}>
                {s}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* Ações */}
      <div style={{ display: 'flex', gap: '7px', flexShrink: 0 }}>
        <button
          onClick={() => onEditar(usuario)}
          style={{ background: 'rgba(79,142,247,0.1)', border: '1px solid rgba(79,142,247,0.3)', borderRadius: '8px', padding: '6px 14px', color: '#4f8ef7', fontSize: '0.78rem', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}
        >
          Editar
        </button>
        {meuId !== usuario.id && (
          confirmando ? (
            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
              <span style={{ fontSize: '0.72rem', color: '#e05555', fontFamily: "'DM Sans', sans-serif" }}>Confirmar?</span>
              <button onClick={() => onDeletar(usuario.id)} style={{ background: 'rgba(224,51,51,0.15)', border: '1px solid #e05555', borderRadius: '7px', padding: '5px 10px', color: '#e05555', fontSize: '0.72rem', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}>Sim</button>
              <button onClick={() => setConfirmando(false)} style={{ background: '#1a1a1a', border: '1px solid #2a2a2a', borderRadius: '7px', padding: '5px 10px', color: '#666', fontSize: '0.72rem', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}>Não</button>
            </div>
          ) : (
            <button
              onClick={() => setConfirmando(true)}
              style={{ background: 'rgba(224,51,51,0.07)', border: '1px solid rgba(224,51,51,0.2)', borderRadius: '8px', padding: '6px 14px', color: '#e05555', fontSize: '0.78rem', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}
            >
              Excluir
            </button>
          )
        )}
      </div>
    </div>
  );
}

// ── Página principal ─────────────────────────────────────────────────────────
export default function Admin() {
  const navigate = useNavigate();
  const usuario  = JSON.parse(localStorage.getItem('usuario') || '{}');

  const [aba,          setAba]          = useState('funcionarios');
  const [usuarios,     setUsuarios]     = useState([]);
  const [carregando,   setCarregando]   = useState(true);
  const [modalAberto,  setModalAberto]  = useState(false);
  const [editando,     setEditando]     = useState(null);
  const [erro,         setErro]         = useState('');

  // Configurações de urgência
  const [urgBaixa,     setUrgBaixa]     = useState('4');
  const [urgMedia,     setUrgMedia]     = useState('12');
  const [salvandoCfg,  setSalvandoCfg]  = useState(false);
  const [msgCfg,       setMsgCfg]       = useState('');
  const [erroCfg,      setErroCfg]      = useState('');

  // Configurações de processos
  const [processosSetor, setProcessosSetor] = useState(PROCESSOS_PADRAO);
  const [setorAberto,    setSetorAberto]    = useState(null);
  const [salvandoProc,   setSalvandoProc]   = useState(false);
  const [msgProc,        setMsgProc]        = useState('');
  const [erroProc,       setErroProc]       = useState('');

  // Bloqueia acesso a não-admins
  useEffect(() => {
    if (usuario.perfil !== 'admin') navigate('/kanban', { replace: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function carregar() {
    setCarregando(true);
    try {
      const dados = await api.getUsuarios();
      setUsuarios(dados);
    } catch (err) {
      setErro(err.message);
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => { carregar(); }, []);

  useEffect(() => {
    api.getConfiguracoes().then((cfg) => {
      setUrgBaixa(cfg.urgencia_baixa_horas || '4');
      setUrgMedia(cfg.urgencia_media_horas || '12');
      if (cfg.processos_setor) setProcessosSetor(cfg.processos_setor);
    }).catch(() => {});
  }, []);

  async function salvarConfiguracoes(e) {
    e.preventDefault();
    setErroCfg(''); setMsgCfg('');
    setSalvandoCfg(true);
    try {
      await api.salvarConfiguracoes({
        urgencia_baixa_horas: urgBaixa,
        urgencia_media_horas: urgMedia,
      });
      setMsgCfg('Configurações salvas com sucesso.');
      setTimeout(() => setMsgCfg(''), 3000);
    } catch (err) {
      setErroCfg(err.message);
    } finally {
      setSalvandoCfg(false);
    }
  }

  async function salvarProcessos() {
    setErroProc(''); setMsgProc('');
    setSalvandoProc(true);
    try {
      const limpo = {};
      for (const [setor, procs] of Object.entries(processosSetor)) {
        limpo[setor] = procs.map(p => p.trim()).filter(p => p.length > 0);
      }
      await api.salvarConfiguracoes({ processos_setor: limpo });
      setProcessosSetor(limpo);
      setMsgProc('Processos salvos com sucesso.');
      setTimeout(() => setMsgProc(''), 3000);
    } catch (err) {
      setErroProc(err.message);
    } finally {
      setSalvandoProc(false);
    }
  }

  function atualizarProcesso(setor, idx, valor) {
    setProcessosSetor(prev => ({ ...prev, [setor]: prev[setor].map((p, i) => i === idx ? valor : p) }));
  }

  function removerProcesso(setor, idx) {
    setProcessosSetor(prev => ({ ...prev, [setor]: prev[setor].filter((_, i) => i !== idx) }));
  }

  function moverProcesso(setor, idx, direcao) {
    setProcessosSetor(prev => {
      const lista = [...prev[setor]];
      const destino = idx + direcao;
      if (destino < 0 || destino >= lista.length) return prev;
      [lista[idx], lista[destino]] = [lista[destino], lista[idx]];
      return { ...prev, [setor]: lista };
    });
  }

  function adicionarProcesso(setor) {
    setProcessosSetor(prev => ({ ...prev, [setor]: [...prev[setor], ''] }));
  }

  async function deletar(id) {
    try {
      await api.deletarUsuario(id);
      setUsuarios(prev => prev.filter(u => u.id !== id));
    } catch (err) {
      alert(err.message);
    }
  }

  function abrirCriar()      { setEditando(null);     setModalAberto(true); }
  function abrirEditar(u)    { setEditando(u);         setModalAberto(true); }
  function fecharModal()     { setModalAberto(false);  setEditando(null); }

  return (
    <div style={{ minHeight: '100vh', background: '#0d0d0d', fontFamily: "'DM Sans', sans-serif" }}>

      {/* Header */}
      <header style={{ background: '#111', borderBottom: '1px solid #1a1a1a', height: '58px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 2rem', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{ width: '36px', height: '36px', background: '#f0a500', borderRadius: '7px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <span style={{ fontFamily: "'Bebas Neue', cursive", color: '#0d0d0d', fontSize: '15px' }}>GM</span>
          </div>
          <span style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.4rem', color: '#e0e0e0', letterSpacing: '0.08em' }}>
            PAINEL ADMIN
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button
            onClick={() => navigate('/kanban')}
            style={{ background: 'transparent', border: '1px solid #2a2a2a', borderRadius: '8px', padding: '6px 14px', color: '#666', fontSize: '0.78rem', cursor: 'pointer', transition: 'all 0.15s' }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = '#555'; e.currentTarget.style.color = '#aaa'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.color = '#666'; }}
          >
            ← Voltar ao Kanban
          </button>
        </div>
      </header>

      {/* Abas */}
      <div style={{ borderBottom: '1px solid #1a1a1a', background: '#111' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 1.5rem', display: 'flex', gap: '4px' }}>
          {[
            { id: 'funcionarios', label: 'Funcionários' },
            { id: 'configuracoes', label: 'Configurações' },
          ].map(a => (
            <button
              key={a.id}
              onClick={() => setAba(a.id)}
              style={{
                background: 'transparent', border: 'none', borderBottom: `2px solid ${aba === a.id ? '#f0a500' : 'transparent'}`,
                padding: '12px 18px', color: aba === a.id ? '#f0a500' : '#555',
                fontFamily: "'DM Sans', sans-serif", fontSize: '0.85rem', fontWeight: aba === a.id ? 700 : 400,
                cursor: 'pointer', transition: 'all 0.15s',
              }}
            >
              {a.label}
            </button>
          ))}
        </div>
      </div>

      {/* Conteúdo */}
      <main style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1.5rem' }}>

        {/* ── ABA FUNCIONÁRIOS ── */}
        {aba === 'funcionarios' && (<>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
            <div>
              <h1 style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '2rem', color: '#e0e0e0', margin: 0, letterSpacing: '0.08em' }}>FUNCIONÁRIOS</h1>
              <p style={{ color: '#555', fontSize: '0.85rem', margin: '4px 0 0 0' }}>Gerencie os colaboradores, cargos e permissões de acesso aos setores.</p>
            </div>
            <button
              onClick={abrirCriar}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#f0a500', border: '1px solid #f0a500', borderRadius: '10px', padding: '9px 18px', color: '#0d0d0d', fontSize: '0.85rem', fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", transition: 'all 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.background = '#d9940a'}
              onMouseLeave={e => e.currentTarget.style.background = '#f0a500'}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Novo Funcionário
            </button>
          </div>

          <div style={{ display: 'flex', gap: '12px', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
            {[
              { label: 'Total', valor: usuarios.length, cor: '#4f8ef7' },
              { label: 'Admins', valor: usuarios.filter(u => u.perfil === 'admin').length, cor: '#f0a500' },
              { label: 'Acesso total', valor: usuarios.filter(u => u.acesso_total && u.perfil !== 'admin').length, cor: '#4ade80' },
              { label: 'Funcionários', valor: usuarios.filter(u => u.perfil !== 'admin').length, cor: '#a78bfa' },
            ].map(c => (
              <div key={c.label} style={{ background: '#141414', border: '1px solid #1e1e1e', borderRadius: '10px', padding: '10px 18px', display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                <span style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.6rem', color: c.cor }}>{c.valor}</span>
                <span style={{ fontSize: '0.78rem', color: '#555' }}>{c.label}</span>
              </div>
            ))}
          </div>

          {carregando && <p style={{ color: '#555', textAlign: 'center', padding: '2rem' }}>Carregando...</p>}
          {erro && <p style={{ color: '#e05555', textAlign: 'center' }}>{erro}</p>}
          {!carregando && !erro && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {usuarios.length === 0 ? (
                <p style={{ color: '#555', textAlign: 'center', padding: '3rem' }}>Nenhum funcionário cadastrado.</p>
              ) : (
                usuarios.map(u => (
                  <CardFuncionario key={u.id} usuario={u} meuId={usuario.id} onEditar={abrirEditar} onDeletar={deletar} />
                ))
              )}
            </div>
          )}
        </>)}

        {/* ── ABA CONFIGURAÇÕES ── */}
        {aba === 'configuracoes' && (
          <div style={{ maxWidth: '660px' }}>
            <h1 style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '2rem', color: '#e0e0e0', margin: '0 0 6px 0', letterSpacing: '0.08em' }}>CONFIGURAÇÕES</h1>
            <p style={{ color: '#555', fontSize: '0.85rem', margin: '0 0 2rem 0' }}>Ajuste os parâmetros de funcionamento do sistema.</p>

            {/* Card de urgência */}
            <div style={{ background: '#141414', border: '1px solid #1e1e1e', borderRadius: '14px', padding: '1.5rem', marginBottom: '1.5rem' }}>
              <h2 style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.2rem', color: '#e0e0e0', margin: '0 0 6px 0', letterSpacing: '0.06em' }}>INDICADORES DE URGÊNCIA</h2>
              <p style={{ fontSize: '0.82rem', color: '#555', margin: '0 0 1.5rem 0' }}>Define em quantas horas um item muda de nível de urgência no Kanban.</p>

              <form onSubmit={salvarConfiguracoes}>
                {/* Visualização atual */}
                <div style={{ display: 'flex', gap: '8px', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
                  {[
                    { label: `0h – ${urgBaixa}h`, cor: '#4ade80', texto: 'Baixa urgência' },
                    { label: `${urgBaixa}h – ${urgMedia}h`, cor: '#f0a500', texto: 'Média urgência' },
                    { label: `${urgMedia}h+`, cor: '#e05555', texto: 'Alta urgência' },
                  ].map(faixa => (
                    <div key={faixa.texto} style={{ flex: 1, minWidth: '120px', background: faixa.cor + '10', border: `1px solid ${faixa.cor}30`, borderRadius: '10px', padding: '10px 14px' }}>
                      <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.7rem', color: faixa.cor, fontWeight: 700, margin: '0 0 3px 0', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{faixa.texto}</p>
                      <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.88rem', color: faixa.cor, margin: 0 }}>{faixa.label}</p>
                    </div>
                  ))}
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '1.25rem' }}>
                  <div>
                    <label style={{ ...labelStyle, color: '#4ade80' }}>Baixa → Média (horas)</label>
                    <input
                      type="number" min="0.5" step="0.5"
                      value={urgBaixa}
                      onChange={e => setUrgBaixa(e.target.value)}
                      style={{ ...inputStyle, borderColor: '#4ade8040' }}
                      onFocus={e => e.target.style.borderColor = '#4ade80'}
                      onBlur={e => e.target.style.borderColor = '#4ade8040'}
                    />
                  </div>
                  <div>
                    <label style={{ ...labelStyle, color: '#f0a500' }}>Média → Alta (horas)</label>
                    <input
                      type="number" min="1" step="0.5"
                      value={urgMedia}
                      onChange={e => setUrgMedia(e.target.value)}
                      style={{ ...inputStyle, borderColor: '#f0a50040' }}
                      onFocus={e => e.target.style.borderColor = '#f0a500'}
                      onBlur={e => e.target.style.borderColor = '#f0a50040'}
                    />
                  </div>
                </div>

                {erroCfg && <p style={{ color: '#e05555', fontSize: '0.85rem', margin: '0 0 1rem 0' }}>{erroCfg}</p>}
                {msgCfg  && <p style={{ color: '#4ade80', fontSize: '0.85rem', margin: '0 0 1rem 0' }}>{msgCfg}</p>}

                <button
                  type="submit" disabled={salvandoCfg}
                  style={{ ...btnStyle, background: '#f0a500', border: '1px solid #f0a500', color: '#0d0d0d', fontWeight: 700, opacity: salvandoCfg ? 0.7 : 1 }}
                  onMouseEnter={e => { if (!salvandoCfg) e.currentTarget.style.background = '#d9940a'; }}
                  onMouseLeave={e => { if (!salvandoCfg) e.currentTarget.style.background = '#f0a500'; }}
                >
                  {salvandoCfg ? 'Salvando...' : 'Salvar configurações'}
                </button>
              </form>
            </div>
            {/* Card de processos */}
            <div style={{ background: '#141414', border: '1px solid #1e1e1e', borderRadius: '14px', padding: '1.5rem' }}>
              <h2 style={{ fontFamily: "'Bebas Neue', cursive", fontSize: '1.2rem', color: '#e0e0e0', margin: '0 0 6px 0', letterSpacing: '0.06em' }}>PROCESSOS POR SETOR</h2>
              <p style={{ fontSize: '0.82rem', color: '#555', margin: '0 0 1.25rem 0' }}>Configure os itens do checklist que cada setor deve concluir antes de avançar.</p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '1.25rem' }}>
                {SETORES.map(setor => {
                  const cor = COR_SETOR[setor] || '#888';
                  const procs = processosSetor[setor] || [];
                  const aberto = setorAberto === setor;
                  return (
                    <div key={setor} style={{ border: `1px solid ${aberto ? cor + '50' : '#222'}`, borderRadius: '10px', overflow: 'hidden', transition: 'border-color 0.15s' }}>
                      <button
                        type="button"
                        onClick={() => setSetorAberto(aberto ? null : setor)}
                        style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', background: aberto ? cor + '12' : '#1a1a1a', border: 'none', cursor: 'pointer', transition: 'background 0.15s' }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: cor, flexShrink: 0 }} />
                          <span style={{ fontSize: '0.85rem', fontWeight: 600, color: aberto ? cor : '#ccc', fontFamily: "'DM Sans', sans-serif" }}>{setor}</span>
                          <span style={{ fontSize: '0.72rem', color: '#444', fontFamily: "'DM Sans', sans-serif" }}>{procs.length} processo{procs.length !== 1 ? 's' : ''}</span>
                        </div>
                        <span style={{ color: '#555', fontSize: '0.75rem', transition: 'transform 0.15s', display: 'inline-block', transform: aberto ? 'rotate(180deg)' : 'none' }}>▾</span>
                      </button>

                      {aberto && (
                        <div style={{ padding: '12px 14px', background: '#111', borderTop: `1px solid ${cor}20` }}>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '10px' }}>
                            {procs.map((proc, i) => (
                              <div key={i} style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', flexShrink: 0 }}>
                                  <button
                                    type="button"
                                    onClick={() => moverProcesso(setor, i, -1)}
                                    disabled={i === 0}
                                    style={{ background: 'transparent', border: '1px solid #2a2a2a', borderRadius: '4px', padding: '1px 5px', color: i === 0 ? '#333' : '#666', fontSize: '0.6rem', cursor: i === 0 ? 'default' : 'pointer', lineHeight: 1 }}
                                  >▲</button>
                                  <button
                                    type="button"
                                    onClick={() => moverProcesso(setor, i, 1)}
                                    disabled={i === procs.length - 1}
                                    style={{ background: 'transparent', border: '1px solid #2a2a2a', borderRadius: '4px', padding: '1px 5px', color: i === procs.length - 1 ? '#333' : '#666', fontSize: '0.6rem', cursor: i === procs.length - 1 ? 'default' : 'pointer', lineHeight: 1 }}
                                  >▼</button>
                                </div>
                                <input
                                  value={proc}
                                  onChange={e => atualizarProcesso(setor, i, e.target.value)}
                                  maxLength={200}
                                  style={{ ...inputStyle, flex: 1, padding: '7px 10px', fontSize: '0.83rem' }}
                                />
                                <button
                                  type="button"
                                  onClick={() => removerProcesso(setor, i)}
                                  style={{ background: 'rgba(224,51,51,0.08)', border: '1px solid rgba(224,51,51,0.2)', borderRadius: '7px', padding: '5px 10px', color: '#e05555', fontSize: '0.9rem', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}
                                >
                                  ×
                                </button>
                              </div>
                            ))}
                          </div>
                          <button
                            type="button"
                            onClick={() => adicionarProcesso(setor)}
                            style={{ background: 'transparent', border: `1px dashed ${cor}40`, borderRadius: '7px', padding: '6px 12px', color: cor + 'bb', fontSize: '0.78rem', cursor: 'pointer', width: '100%', fontFamily: "'DM Sans', sans-serif" }}
                          >
                            + Adicionar processo
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {erroProc && <p style={{ color: '#e05555', fontSize: '0.85rem', margin: '0 0 1rem 0' }}>{erroProc}</p>}
              {msgProc  && <p style={{ color: '#4ade80', fontSize: '0.85rem', margin: '0 0 1rem 0' }}>{msgProc}</p>}

              <button
                onClick={salvarProcessos}
                disabled={salvandoProc}
                style={{ ...btnStyle, background: '#f0a500', border: '1px solid #f0a500', color: '#0d0d0d', fontWeight: 700, opacity: salvandoProc ? 0.7 : 1 }}
                onMouseEnter={e => { if (!salvandoProc) e.currentTarget.style.background = '#d9940a'; }}
                onMouseLeave={e => { if (!salvandoProc) e.currentTarget.style.background = '#f0a500'; }}
              >
                {salvandoProc ? 'Salvando...' : 'Salvar processos'}
              </button>
            </div>
          </div>
        )}

      </main>

      {modalAberto && (
        <ModalFuncionario
          usuario={editando}
          onClose={fecharModal}
          onSalvo={carregar}
        />
      )}
    </div>
  );
}
